// extracted by mini-css-extract-plugin
export var section = "blog-module--section--E6-qC";
export var inner = "blog-module--inner--7pjIj";
export var jsAnimInit = "blog-module--jsAnimInit--36hTN";
export var header = "blog-module--header--1iq13";
export var subtitle = "blog-module--subtitle--YZ8Wh";
export var link = "blog-module--link--3F6BG";